import {AppActions, useAppContext} from "../context/AppContext";
import ApiService from "../services/ApiService";

// Shared project-upload handler used by the upload page (/app/load-project) and
// the inline drop areas on the /app/run and /app/results empty states. Persists
// each project's metadata to the backend and pushes the parsed projects into
// app context. Kept in one place so the call sites can't drift.
export default function useUploadProject() {
    const {dispatchProject} = useAppContext()

    return async (projects) => {
        for (const project of projects) {
            try {
                const data = project?.projectFiles?.map(prj => ({
                    projectTitle: project.information.title,
                    flowTitle: prj.flow.title,
                    planTitle: prj.plan.title,
                    geometryTitle: prj.geometry.title,
                    projectHash: prj.projectHash
                }))

                await ApiService.UserProject.UploadProject(data);
            }
            catch (exp) {
                console.log(exp)
            }
        }

        dispatchProject({
            type: AppActions.SET_PROJECTS,
            data: {
                projects: projects
            }
        })
    }
}
